import React, { useEffect } from "react";
import bannerImage from "../images/slider20.jpg";
import logoImage from "../images/logo.png";
import AOS from "aos";
import "aos/dist/aos.css";

const Header = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Whether the animation should happen only once
      offset: 100, // Offset (in pixels) from the element's position to trigger the animation
    });
  }, []);

  return (
    <div>
      <div className="relative">
        {/* <img
                    className="w-full h-[240px] lg:h-[380px] object-cover"
                    src={bannerImage}
                    alt="banner"
                    style={{ clipPath: 'polygon(100% 0, 100% 87%, 50% 100%, 0 87%, 0 0)' }}
                /> */}

        <img
          className="w-full h-[240px] lg:h-[380px] object-cover"
          src={bannerImage}
          alt="banner"
        />

        <img
          className="mt-[-35px] mx-auto   w-[180px] lg:w-[200px] relative z-10 "
          src={logoImage}
          alt="logo"
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="700"
          data-aos-delay="350"
        />
        {/* 
                <img
                    className="mt-[-35px] mx-auto w-[180px] lg:w-[200px] relative z-10  shadow-xl"
                    src={logoImage}
                    alt="logo"
                    data-aos="fade-down"
                    data-aos-easing="linear"
                    data-aos-duration="700"
                    data-aos-delay="350"
                /> */}
      </div>
      <h1 className="text-sm my-2 font-bold gold-text text-center">
        תודיעני ארח חיים שבע שמחות את פניך נעמות בימינך נצח
      </h1>

      <div className="mt-4">
        <h1
          data-aos="fade-zoom-in"
          data-aos-easing="linear"
          data-aos-duration="500"
          data-aos-delay="600"
          className="text-3xl text-center font-bold text-businessName"
        >
          שובע שמחות{" "}
        </h1>
        <h2
          data-aos="fade-zoom-in"
          data-aos-easing="linear"
          data-aos-duration="500"
          data-aos-delay="700"
          className="text-xl text-center font-semibold text-businessDescription"
        >
          אוכל ביתי איכותי
        </h2>
      </div>
    </div>
  );
};

export default Header;
